var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row row-cols-4" },
      _vm._l(_vm.posts, function (post) {
        return _c(
          "div",
          { key: post.id, staticClass: "col" },
          [_c("video-card", { attrs: { post: post } })],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.enabled,
            expression: "enabled",
          },
        ],
        staticClass: "title-section commentsSect",
        on: { click: _vm.getVideos },
      },
      [
        _c("h3", { staticClass: "heading-title-sect text-center" }, [
          _c("span", [_vm._v("MÁS " + _vm._s(_vm.sName))]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }